/* theme.js — Gilded Shimmer Soaps */

(function () {
  'use strict';

  /* ── HEADER SCROLL + HEIGHT TRACKING ── */
  const header = document.getElementById('site-header');
  if (header) {
    const setHeaderHeight = () => {
      document.documentElement.style.setProperty('--header-height', header.offsetHeight + 'px');
    };
    const onScroll = () => header.classList.toggle('scrolled', window.scrollY > 60);
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', setHeaderHeight, { passive: true });
    onScroll();
    setHeaderHeight();
  }

  /* ── MOBILE MENU ── */
  const mobileToggle = document.querySelector('[data-mobile-toggle]');
  const mobileNav    = document.getElementById('mobile-nav');
  if (mobileToggle && mobileNav) {
    mobileToggle.addEventListener('click', () => {
      const open = mobileNav.classList.toggle('open');
      mobileToggle.setAttribute('aria-expanded', open);
      mobileNav.setAttribute('aria-hidden', !open);
    });
  }

  /* ── CART DRAWER ── */
  const cartOverlay  = document.getElementById('cart-overlay');
  const cartDrawer   = document.getElementById('cart-drawer');
  const cartToggles  = document.querySelectorAll('[data-cart-toggle]');
  const cartClose    = document.querySelector('[data-cart-close]');

  function openCart() {
    cartOverlay?.classList.add('open');
    cartDrawer?.classList.add('open');
    cartDrawer?.setAttribute('aria-hidden', 'false');
    cartToggles.forEach(btn => btn.setAttribute('aria-expanded', 'true'));
    document.body.style.overflow = 'hidden';
  }

  function closeCart() {
    cartOverlay?.classList.remove('open');
    cartDrawer?.classList.remove('open');
    cartDrawer?.setAttribute('aria-hidden', 'true');
    cartToggles.forEach(btn => btn.setAttribute('aria-expanded', 'false'));
    document.body.style.overflow = '';
  }

  cartToggles.forEach(btn => btn.addEventListener('click', openCart));
  cartClose?.addEventListener('click', closeCart);
  cartOverlay?.addEventListener('click', closeCart);

  // Close on Escape
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape' && cartDrawer?.classList.contains('open')) closeCart();
  });

  /* ── TOAST ── */
  window.showToast = function (msg, duration = 2500) {
    const toast = document.getElementById('toast');
    if (!toast) return;
    toast.textContent = msg;
    toast.classList.add('show');
    clearTimeout(toast._timer);
    toast._timer = setTimeout(() => toast.classList.remove('show'), duration);
  };

  /* ── PRODUCT PAGE: gallery thumbnails ── */
  const thumbs = document.querySelectorAll('.product-gallery__thumb');
  const mainImg = document.querySelector('.product-gallery__main img');
  if (thumbs.length && mainImg) {
    thumbs.forEach((thumb, index) => {
      thumb.addEventListener('click', () => {
        thumbs.forEach(t => t.classList.remove('active'));
        thumb.classList.add('active');
        const src = thumb.dataset.src;
        const srcset = thumb.dataset.srcset;
        const zoom = thumb.dataset.zoom;
        const alt = thumb.dataset.alt;
        if (src) mainImg.src = src;
        if (srcset) mainImg.srcset = srcset;
        if (zoom) mainImg.dataset.zoom = zoom;
        if (alt) mainImg.alt = alt;
        mainImg.dataset.activeIndex = index;
      });
    });
  }

  /* ── PRODUCT PAGE: image zoom lightbox ── */
  (function () {
    const lightbox = document.getElementById('image-lightbox');
    const lightboxImg = document.getElementById('image-lightbox-img');
    const zoomable = document.querySelector('.product-gallery__zoomable');
    const zoomHint = document.querySelector('.product-gallery__zoom-hint');
    if (!lightbox || !lightboxImg || !zoomable) return;

    const allThumbs = document.querySelectorAll('.product-gallery__thumb');
    const counter = lightbox.querySelector('[data-lightbox-counter]');
    let currentIndex = 0;

    function buildImageList() {
      if (allThumbs.length > 0) {
        return Array.from(allThumbs).map(t => ({
          zoom: t.dataset.zoom,
          alt: t.dataset.alt || ''
        }));
      }
      return [{ zoom: zoomable.dataset.zoom || zoomable.src, alt: zoomable.alt }];
    }

    const images = buildImageList();

    function showImage(index) {
      if (index < 0) index = images.length - 1;
      if (index >= images.length) index = 0;
      currentIndex = index;
      const img = images[index];
      lightboxImg.src = img.zoom;
      lightboxImg.alt = img.alt;
      if (counter) counter.textContent = (index + 1) + ' / ' + images.length;
    }

    function openLightbox(index) {
      showImage(index);
      lightbox.classList.add('open');
      lightbox.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    function closeLightbox() {
      lightbox.classList.remove('open');
      lightbox.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    // Open on main image click
    zoomable.addEventListener('click', () => {
      const activeIdx = parseInt(zoomable.dataset.activeIndex || 0);
      openLightbox(activeIdx);
    });

    // Hint button opens too
    if (zoomHint) {
      zoomHint.addEventListener('click', () => {
        const activeIdx = parseInt(zoomable.dataset.activeIndex || 0);
        openLightbox(activeIdx);
      });
    }

    // Close button
    lightbox.querySelector('[data-lightbox-close]')?.addEventListener('click', closeLightbox);

    // Click backdrop to close (but not when clicking the image itself)
    lightbox.addEventListener('click', (e) => {
      if (e.target === lightbox || e.target.matches('[data-lightbox-stage]')) {
        closeLightbox();
      }
    });

    // Prev / next
    lightbox.querySelector('[data-lightbox-prev]')?.addEventListener('click', () => showImage(currentIndex - 1));
    lightbox.querySelector('[data-lightbox-next]')?.addEventListener('click', () => showImage(currentIndex + 1));

    // Keyboard
    document.addEventListener('keydown', (e) => {
      if (!lightbox.classList.contains('open')) return;
      if (e.key === 'Escape') closeLightbox();
      else if (e.key === 'ArrowLeft') showImage(currentIndex - 1);
      else if (e.key === 'ArrowRight') showImage(currentIndex + 1);
    });

    // Touch swipe for mobile
    let touchStartX = 0;
    lightbox.addEventListener('touchstart', (e) => {
      touchStartX = e.changedTouches[0].screenX;
    }, { passive: true });
    lightbox.addEventListener('touchend', (e) => {
      const diff = e.changedTouches[0].screenX - touchStartX;
      if (Math.abs(diff) > 50) {
        showImage(currentIndex + (diff < 0 ? 1 : -1));
      }
    }, { passive: true });
  })();

  /* ── PRODUCT PAGE: quantity stepper ── */
  document.addEventListener('click', e => {
    if (e.target.matches('.qty-btn')) {
      const input = e.target.closest('.qty-input-wrap')?.querySelector('.qty-input');
      if (!input) return;
      const delta = e.target.dataset.delta === '-1' ? -1 : 1;
      const newVal = Math.max(1, parseInt(input.value || 1) + delta);
      input.value = newVal;
    }
  });

  /* ── PRODUCT PAGE: variant selector ── */
  (function initProductVariantSwitcher() {
    const variantsScript = document.querySelector('[data-product-variants-json]');
    if (!variantsScript) return;

    let variants;
    try {
      variants = JSON.parse(variantsScript.textContent);
    } catch (err) {
      console.warn('Could not parse product variants JSON', err);
      return;
    }
    if (!Array.isArray(variants) || variants.length === 0) return;

    const form           = document.querySelector('form[data-product-form]');
    const variantInput   = form?.querySelector('[name="id"]');
    const priceEl        = document.querySelector('[data-product-price]');
    const compareEl      = document.querySelector('[data-product-compare]');
    const atcBtn         = document.querySelector('[data-add-to-cart]');
    const optionGroups   = document.querySelectorAll('.variant-options[data-option-position]');

    function formatMoney(cents) {
      return window.Shopify?.formatMoney ?
        window.Shopify.formatMoney(cents) :
        '$' + (cents / 100).toFixed(2);
    }

    function getSelectedOptionValues() {
      // Build an array indexed by option position (1-based -> 0-based)
      const values = [];
      optionGroups.forEach(group => {
        const position = parseInt(group.dataset.optionPosition, 10);
        const selected = group.querySelector('.variant-option.selected');
        if (selected) {
          values[position - 1] = selected.dataset.optionValue;
        }
      });
      return values;
    }

    function findMatchingVariant(selectedValues) {
      return variants.find(v => {
        const variantOptions = v.options || [v.option1, v.option2, v.option3].filter(Boolean);
        return selectedValues.every((val, i) => variantOptions[i] === val);
      });
    }

    function updateForVariant(variant) {
      if (!variant) return;

      // Update price
      if (priceEl) {
        priceEl.textContent = formatMoney(variant.price);
      }

      // Update compare-at price + sale styling
      const onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
      if (compareEl) {
        if (onSale) {
          compareEl.textContent = formatMoney(variant.compare_at_price);
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }
      if (priceEl) {
        priceEl.classList.toggle('product-info__price--sale', !!onSale);
      }

      // Update hidden form input
      if (variantInput) variantInput.value = variant.id;

      // Update Add to Cart button
      if (atcBtn) {
        atcBtn.dataset.variantId = variant.id;
        if (variant.available) {
          atcBtn.disabled = false;
          atcBtn.textContent = atcBtn.dataset.defaultText || 'Add to Cart';
        } else {
          atcBtn.disabled = true;
          atcBtn.textContent = 'Sold Out';
        }
      }

      // Update URL so reloads/shares preserve the variant
      if (window.history?.replaceState) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    document.addEventListener('click', e => {
      const btn = e.target.closest('.variant-option');
      if (!btn || btn.classList.contains('soldout') || btn.disabled) return;
      // Only handle buttons inside the product-page variant selector
      const group = btn.closest('.variant-options[data-option-position]');
      if (!group) return;

      group.querySelectorAll('.variant-option').forEach(o => o.classList.remove('selected'));
      btn.classList.add('selected');

      const selectedValues = getSelectedOptionValues();
      const matchedVariant = findMatchingVariant(selectedValues);
      updateForVariant(matchedVariant);
    });
  })();

  /* ── SMOOTH ANCHOR SCROLL (accounting for fixed header) ── */
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', e => {
      const target = document.querySelector(anchor.getAttribute('href'));
      if (!target) return;
      e.preventDefault();
      const offset = (header?.offsetHeight ?? 80) + 20;
      window.scrollTo({ top: target.offsetTop - offset, behavior: 'smooth' });
    });
  });

  /* ── PRODUCT CARD: VARIANT SELECTION ── */
  document.addEventListener('click', e => {
    const btn = e.target.closest('[data-card-opt-btn]');
    if (!btn || btn.classList.contains('soldout')) return;

    const card = btn.closest('.product-card');
    if (!card) return;

    // Deactivate siblings in same option row
    btn.closest('.product-card__option-btns')
       ?.querySelectorAll('[data-card-opt-btn]')
       .forEach(b => b.classList.remove('active'));
    btn.classList.add('active');

    // Find the variant that matches ALL currently active option buttons
    const activeBtns = card.querySelectorAll('[data-card-opt-btn].active');
    const activeVariantIds = [...activeBtns].map(b => b.dataset.variantId);

    // The selected variant is the one whose ID appears in all active buttons
    // (for single-option products, there's only one active btn)
    // Use the last-clicked button's data as the source of truth for single-option
    const selectedVariantId = btn.dataset.variantId;
    const price             = btn.dataset.price;
    const comparePrice      = btn.dataset.comparePrice;
    const available         = btn.dataset.available === 'true';

    // Update price display
    const priceEl   = card.querySelector('[data-card-price-amount]');
    const compareEl = card.querySelector('[data-card-compare]');

    if (priceEl && price) {
      // Format cents using Shopify money format
      const formatted = window.Shopify?.formatMoney ?
        window.Shopify.formatMoney(parseInt(price)) :
        '$' + (parseInt(price) / 100).toFixed(2);
      priceEl.textContent = formatted;
    }

    if (compareEl) {
      if (comparePrice && parseInt(comparePrice) > parseInt(price)) {
        const fmtCompare = window.Shopify?.formatMoney ?
          window.Shopify.formatMoney(parseInt(comparePrice)) :
          '$' + (parseInt(comparePrice) / 100).toFixed(2);
        compareEl.textContent = fmtCompare;
        compareEl.style.display = '';
      } else {
        compareEl.style.display = 'none';
      }
    }

    // Update Add to Cart button variant ID and availability
    const atcBtn = card.querySelector('[data-add-to-cart]');
    if (atcBtn) {
      atcBtn.dataset.variantId = selectedVariantId;
      if (available) {
        atcBtn.disabled = false;
        atcBtn.textContent = atcBtn.dataset.defaultText || 'Add to Cart';
      } else {
        atcBtn.disabled = true;
        atcBtn.textContent = 'Sold Out';
      }
    }
  });

  /* ── FADE-IN ON SCROLL ── */
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(
      entries => entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('in-view');
          observer.unobserve(entry.target);
        }
      }),
      { threshold: 0.1 }
    );
    document.querySelectorAll('.fade-in').forEach(el => observer.observe(el));
  } else {
    document.querySelectorAll('.fade-in').forEach(el => el.classList.add('in-view'));
  }

  /* ── ANNOUNCEMENT BAR HEIGHT ── */
  /* The header is positioned below the announcement bar. Because the bar's
     text can wrap to a variable number of lines depending on viewport width
     and text length, measure its height at runtime and expose it as a CSS
     variable so .site-header can sit flush against it without overlap or gap. */
  const announcementBar = document.querySelector('.announcement-bar');
  if (announcementBar) {
    const updateAnnouncementHeight = () => {
      const h = announcementBar.offsetHeight;
      document.documentElement.style.setProperty('--announcement-height', h + 'px');
    };
    updateAnnouncementHeight();
    window.addEventListener('resize', updateAnnouncementHeight);
    if ('ResizeObserver' in window) {
      new ResizeObserver(updateAnnouncementHeight).observe(announcementBar);
    }
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(updateAnnouncementHeight);
    }
  }

})();